import MeterAddButtonPresenter from "./MeterAddButton/MeterAddButtonPresenter";
import MeterListPresenter from "./MeterListPresenter";
import MeterSearchPresenter from "./MeterSearch/MeterSearchPresenter";

export const MeterList = {
    List: MeterListPresenter,
    InputSearch: MeterSearchPresenter,
    AddButton: MeterAddButtonPresenter
}
